import ReviewConstants from 'notebook/reviews/ReviewConstants';

import {FILTER_SEPARATOR, FILTER_VALUE_SEPARATOR, FilterKey, FILTERS} from './SearchConstants';

const {ROLE_FILTER_SEPARATOR} = ReviewConstants;

export interface Filter {
  key: FilterKey;
  // oxlint-disable-next-line @typescript-eslint/no-explicit-any
  value: any;
}

/**
 * Converts the list of filter key/value shapes to a query params string
 *
 * For example, [{key: 'PARENT_STORABLE', value: 'root'}] -> 'parentStorable:root'
 * @param {array} filters Array of key/value filter shapes
 */
export default function filtersToArgs(filters: Array<Filter>): {scope: string; queryFilter: string} {
  let queryFilter;
  let scope;
  for (const filter of filters) {
    if (!filter.value) {
      continue;
    }
    if (filter.key === FILTERS.PROJECT.key) {
      scope = filter.value;
      continue;
    }
    const nextFilter = (() => {
      const {key, prefix} = FILTERS[filter.key];
      switch (key) {
        case FILTERS.ARCHIVE_PURPOSES.key:
        case FILTERS.AUTHOR.key:
        case FILTERS.NOTE_REFERENCE.key:
          return prefix + filter.value.join(FILTER_VALUE_SEPARATOR);
        case FILTERS.REVIEW.key:
          return prefix + filter.value.status + ROLE_FILTER_SEPARATOR + filter.value.role;
        // Batch and custom tags are stored and sent as 'tag:'
        case FILTERS.BATCH_TAG.key:
        case FILTERS.CUSTOM_TAG.key:
          return `${FILTERS.TAG.prefix}${filter.value}`;
        default:
          return prefix ? `${prefix}${filter.value}` : filter.value;
      }
    })();
    if (queryFilter != null) {
      queryFilter += FILTER_SEPARATOR + nextFilter;
    } else {
      queryFilter = nextFilter;
    }
  }
  return {scope, queryFilter};
}
